// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_1eKkL","hidden":"qz6bt","tooltip":"_3h4_s","showAsText":"VVK-0","tooltipVisible":"_1gTgn","tooltipInner":"hVcPo"};